import { render, staticRenderFns } from "./ManageDiagnosis.vue?vue&type=template&id=f3f2c092&scoped=true&"
import script from "./ManageDiagnosis.vue?vue&type=script&lang=js&"
export * from "./ManageDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./ManageDiagnosis.vue?vue&type=style&index=0&id=f3f2c092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f2c092",
  null
  
)

export default component.exports